import { createContext } from 'react';

const ApprovalCardElevationContext = createContext(false);

export default ApprovalCardElevationContext;
